import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a floor-standing cylindrical water heater tank, 0.5 m
// diameter x 1.5 m high: white body, two pipe stubs on top, a small dial on
// the front (+Z).
const WARM_WHITE = "#efece6";
const STEEL = "#aab2b8";
const MATTE_BLACK = "#2e2e30";

export const waterHeater = defineModel({
  id: "water-heater",
  batchId: "modern",
  name: "Water Heater",
  tags: ["modern", "interior", "appliance", "utility", "plumbing", "heating"],
  summary: "A floor-standing white cylindrical water tank with top pipe stubs and a dial.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // tank body
      { geometry: new THREE.CylinderGeometry(0.25, 0.25, 1.4, 14), color: WARM_WHITE, position: [0, 0.72, 0] },
      // top cap
      { geometry: new THREE.CylinderGeometry(0.22, 0.25, 0.08, 14), color: WARM_WHITE, position: [0, 1.46, 0] },
      // base ring
      { geometry: new THREE.CylinderGeometry(0.26, 0.26, 0.04, 14), color: STEEL, position: [0, 0.02, 0] },
      // two pipe stubs on top
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.14, 8), color: STEEL, position: [-0.1, 1.55, 0] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.14, 8), color: STEEL, position: [0.1, 1.55, 0] },
      // small dial on the front: black rim + steel face
      {
        geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.03, 10),
        color: MATTE_BLACK,
        position: [0, 0.6, 0.25],
        rotation: [Math.PI / 2, 0, 0],
      },
      {
        geometry: new THREE.CylinderGeometry(0.035, 0.035, 0.012, 10),
        color: STEEL,
        position: [0, 0.6, 0.262],
        rotation: [Math.PI / 2, 0, 0],
      },
    ];
  },
  animations: [],
});
